import { InquiryCustomCakeFilling } from "../InquiryCustomCakeFilling.js";
import { Locale, type LocalizedString } from "../Locale.js";

export const inquiryCustomCakeFillingNameMap: Record<InquiryCustomCakeFilling, LocalizedString> = {
	[InquiryCustomCakeFilling.FruityBright]: {
		[Locale.cs]: "Ovocný - světlý",
	},
	[InquiryCustomCakeFilling.FruityDark]: {
		[Locale.cs]: "Ovocný tmavý",
	},
	[InquiryCustomCakeFilling.LemonRaspberry]: {
		[Locale.cs]: "Citrónový s malinami",
	},
	[InquiryCustomCakeFilling.ChocoRaspberry]: {
		[Locale.cs]: "Čokoládový s malinami",
	},
	[InquiryCustomCakeFilling.Bueno]: {
		[Locale.cs]: "Bueno",
	},
	[InquiryCustomCakeFilling.PistachioRaspberry]: {
		[Locale.cs]: "Pistáciový s malinami",
	},
};
